import * as React from 'react'

export const GoogleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16 8.187C16 12.752 12.823 16 8.131 16 3.633 16 0 12.426 0 8s3.633-8 8.131-8c2.19 0 4.033.79 5.453 2.094L11.37 4.187C8.474 1.44 3.09 3.503 3.09 8c0 2.79 2.266 5.052 5.04 5.052 3.22 0 4.426-2.271 4.617-3.449H8.13V6.852h7.741c.075.41.128.803.128 1.335Z"
      fill="#282421"
    />
  </svg>
)
